import styled from "styled-components";

export const RatingContainer = styled.div`
    position: relative;

    height: 58px;
    padding: ${p => p.theme.componentSmallInnerVerticalPadding}px ${p => p.theme.pageMarginMedium}px;

    display: flex;
    justify-content: space-between;
    align-items: center;

    line-height: 120%;

    & .rating-icon {
        width: 40px;
        height: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
`;

export const RightContainer = styled.div<{ enabled: boolean }>`
    display: flex;
    justify-content: center;
    pointer-events: ${p => p.enabled !== false ? "auto" : "none"};
`;
